import { Box, Stack } from "@mui/material";
import { FC, useState } from "react";
import SelectInput from "../UIElements/select";
import { LoadingButton } from "@mui/lab";
import { categoryType } from "./data";
import { departmentOptions, jobTitle } from "../jobManagement/data";

export const FilterFacilityInputs: FC<{
  loading: boolean;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setFilterData, loading }) => {
  const [filters, setFilters] = useState({
    facility_type: "",
  });
  const handleFilterClicked = () => {
    setFilterData(`filter[facility_type]=${filters.facility_type}`);
  };
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", my: 2, gap: 2, px: 2 }}>
      <Stack sx={{ width: 200 }}>
        <SelectInput
          label={"Facility type"}
          value={filters?.facility_type}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              facility_type: e.target.value,
            }))
          }
          options={categoryType}
        />
      </Stack>
      {/* <Stack sx={{ width: 200 }}>
        <SelectInput
          label={"Status"}
          value={""}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, status: e.target.value }))
          }
          options={[
            { value: "draft", label: "Draft" },
            { value: "pending", label: "Pending" },
            { value: "closed", label: "Closed" },
          ]}
        />
      </Stack> */}
      <Stack
        sx={{ width: 150, mx: 3 }}
        direction={"row"}
        alignItems={"flex-end"}
      >
        <LoadingButton
          onClick={handleFilterClicked}
          loading={loading}
          variant="contained"
          sx={{ my: 3, width: 80 }}
        >
          Filter
        </LoadingButton>
      </Stack>
    </Box>
  );
};

export const FilterEmploymentInputs: FC<{
  loading: boolean;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setFilterData, loading }) => {
  const [job_filter, setJob_filter] = useState({
    job_title: "",
    department: "",
    status: "",
  });

  const handleFilterClicked = () => {
    setFilterData(
      `filter[job_title]=${job_filter.job_title}&filter[department]=${job_filter.department}&filter[status]=${job_filter.status}`
    );
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        background: "white",
        borderRadius: "6px",
      }}
    >
      <Stack sx={{ width: 150 }}>
        <SelectInput
          label={"Job Title"}
          value={job_filter.job_title}
          onChange={(e) =>
            setJob_filter((prev) => ({ ...prev, job_title: e.target.value }))
          }
          options={jobTitle}
        />
      </Stack>
      <Stack sx={{ width: 150 }}>
        <SelectInput
          label={"Department"}
          value={job_filter.department}
          onChange={(e) =>
            setJob_filter((prev) => ({ ...prev, department: e.target.value }))
          }
          options={departmentOptions}
        />
      </Stack>

      <Stack sx={{ width: 150 }}>
        <SelectInput
          label={"Status"}
          value={job_filter.status}
          onChange={(e) =>
            setJob_filter((prev) => ({ ...prev, status: e.target.value }))
          }
          options={[
            { value: "active", label: "Active" },
            { value: "pending", label: "Pending" },
            { value: "closed", label: "Closed" },
          ]}
        />
      </Stack>
      <Stack
        sx={{ width: 150, mx: 3 }}
        direction={"row"}
        alignItems={"flex-end"}
      >
        <LoadingButton
          onClick={handleFilterClicked}
          loading={loading}
          variant="contained"
          sx={{ my: 3, width: 80 }}
        >
          Filter
        </LoadingButton>
      </Stack>
    </Box>
  );
};

export const FilterJobsInputs: FC<{
  loading: boolean;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setFilterData, loading }) => {
  const [job_filter, setJob_filter] = useState({
    job_title: "",
    job_type: "",
    status: "",
  });

  const handleFilterClicked = () => {
    setFilterData(
      `filter[job_title]=${job_filter.job_title}&filter[job_type]=${job_filter.job_type}&filter[status]=${job_filter.status}`
    );
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        mx: 3
      }}
    >
      <Stack sx={{ width: 150 }}>
        <SelectInput
          label={"Job Title"}
          value={job_filter.job_title}
          onChange={(e) =>
            setJob_filter((prev) => ({ ...prev, job_title: e.target.value }))
          }
          options={jobTitle}
        />
      </Stack>

      <Stack sx={{ width: 150 }}>
        <SelectInput
          label={"Job Type"}
          value={job_filter.job_type}
          onChange={(e) =>
            setJob_filter((prev) => ({ ...prev, job_type: e.target.value }))
          }
          options={[
            { value: "full time", label: "Full time" },
            { value: "temporary", label: "Temporary" },
          ]}
        />
      </Stack>
      <Stack sx={{ width: 150 }}>
        <SelectInput
          label={"Status"}
          value={job_filter.status}
          onChange={(e) =>
            setJob_filter((prev) => ({ ...prev, status: e.target.value }))
          }
          options={[
            { value: "active", label: "Active" },
            { value: "pending", label: "Pending" },
            { value: "closed", label: "Closed" },
          ]}
        />
      </Stack>
      <Stack
        sx={{ width: 150, mx: 3 }}
        direction={"row"}
        alignItems={"flex-end"}
      >
        <LoadingButton
          onClick={handleFilterClicked}
          loading={loading}
          variant="contained"
          sx={{ my: 3, width: 80 }}
        >
          Filter
        </LoadingButton>
      </Stack>
    </Box>
  );
};
